import { __module as e } from "../../../_virtual/isInt.js";
import { a as t } from "./util/assertString.js";
Object.defineProperty(r = e.exports, "__esModule", {
  value: !0
}), r.default = function (e, t) {
  (0, a.default)(e);
  var r = (t = t || {}).hasOwnProperty("allow_leading_zeroes") && !t.allow_leading_zeroes ? o : s,
    l = !t.hasOwnProperty("min") || e >= t.min,
    n = !t.hasOwnProperty("max") || e <= t.max,
    i = !t.hasOwnProperty("lt") || e < t.lt,
    p = !t.hasOwnProperty("gt") || e > t.gt;
  return r.test(e) && l && n && i && p;
}, a = t && t.__esModule ? t : {
  default: t
}, o = /^(?:[-+]?(?:0|[1-9][0-9]*))$/, s = /^[-+]?[0-9]+$/, e.exports = r.default, e.exports.default = r.default;
var r,
  a,
  o,
  s,
  l = e.exports;
export { l as i };